import {Theme} from '@mui/material/styles';

export const mobileDialogSx = (theme: Theme) => ({
    [theme.breakpoints.down('sm')]: {
        '& .MuiDialog-paper': {
            m: 2,
            width: 'calc(100% - 32px)',
            maxWidth: 'calc(100% - 32px)',
            p: 0,
        },
        '& .MuiDialogTitle-root': {
            px: 2.5,
            pt: 3,
            pb: 2,
        },
        '& .MuiDialogContent-root': {
            px: 2.5,
        },
        '& .MuiDialogActions-root': {
            px: 2.5,
            pb: 2.5,
            pt: 1,
            gap: 1,
        },
        '& .MuiDialogActions-root > .MuiButton-root': {
            flex: 1,
            minWidth: 0,
            ml: 0,
            height: 40,
            py: 0,
            px: 1,
            whiteSpace: 'nowrap',
        },
    },
});
